import React, { Component } from 'react';
import cookie from '../../src/cookiecut.png';
import { Button } from '@blueprintjs/core';
import{withRouter,Link} from 'react-router-dom';
import { observer , inject } from 'mobx-react';



@withRouter
@inject("store")
@observer

export default class Whynotwrite extends Component
{

  
    render()
    {
        return  <div className = "writenowrite">
           {this.props.store.whynowrite == "nothing"?<>是因为什么没有写呢？</>
            :<><div className="soga">
                原来是这样啊 {this.props.store.whynowrite ?<div className = "nowritetext"><br/>那真的太巧了！<br/>这里就有一个“从无到有”，<br/>教你写小故事的指南哦，<br/>快去看看吧！</div>
                :<div className = "nowritetext"><br/>但是不开始写的话，<br/>学多少技巧都没有用武之地哦。<br/>就像玩过游戏之后，看攻略才能理解，只学理论却不写是不行的<br/>赶快跟着“从无到有”小故事指南开始写吧！</div>}
                  <Link to="/zerotoone"><Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.props.store.zerooo= "nothing"} >教你"从无到有"的小故事指南</Button></Link>
                </div></>}
            
    
        </div>;
    }
} 